import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AnnualReportProvider } from '@modeso/aumico-lib-annualreport-fe';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { filter, switchMap, take, timeout } from 'rxjs/operators';
import { Paths } from '../../../../enums/paths.enum';
import { LastVisitedImportTabService } from '../../services/last-visited-import-tab.service';

@UntilDestroy()
@Component({
    selector: 'aumico-import-redirect-page',
    template: '',
})
export class ImportRedirectPage implements OnInit {
    constructor(
        private router: Router,
        private route: ActivatedRoute,
        private lastVisitedImportTabService: LastVisitedImportTabService,
        private annualReportProvider: AnnualReportProvider,
    ) { }

    ngOnInit(): void {
        this.annualReportProvider
            .getActiveAnnualReport$()
            .pipe(
                filter((ar) => ar != null && ar._id != null),
                take(1),
                switchMap((ar) => this.lastVisitedImportTabService.getLastVisitedTab(ar._id)),
                timeout(500), // 0.5 second timeout
                untilDestroyed(this),
            )
            .subscribe({
                next: (lastTab) => {
                    const redirectTo = lastTab || Paths.MAPPING;
                    this.router.navigate([redirectTo], { relativeTo: this.route, replaceUrl: true });
                },
                error: () => {
                    // On timeout, redirect to default path
                    this.router.navigate([Paths.MAPPING], { relativeTo: this.route, replaceUrl: true });
                },
            });
    }
}
